import _ from "lodash";
import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { URL } from "../constant";
import { setLearningHistory } from "../redux/user";

const getHistoryInfo = state => state.user.learningHistory;

export default function useLearningHistory() {
  const dispatch = useDispatch();
  const learningHistoryInfo = useSelector(getHistoryInfo);
  const history = useHistory();
  
  const setLearningHistoryInfo = useCallback((data) => {
    dispatch(setLearningHistory(data))
  }, [dispatch]);

  const onLearninStartBtn = useCallback((info) => {
    const { type = 'push', viewPath } = info;
    let path =  { pathname : `${URL.COURSE_LEARNING.AI_DIAGNOSIS_TEST.DIAGNOSIS_GUIDE1}`};

    if(!_.isEmpty(viewPath)) {
      dispatch(setLearningHistory({
        enterViewPath : viewPath,
      }));
    }

    if(_.isEqual(type, 'replace')) {
      history.replace(path);
    } else {
      history.push(path);
    }
  });

  const onLearningExitBtn = useCallback(() => {
    const { enterViewPath } = learningHistoryInfo;

    if(!_.isEmpty(enterViewPath)) {
      
      switch(enterViewPath) {
        case '/courseLearning/learningNote' :
          // 글러벌일 때 진단테스트 결과 없을 시 학습노트 주제학습 텝으로
          history.push({
            pathname : URL.COURSE_LEARNING.LEARNING_NOTE,
            state : learningHistoryInfo.isCompleteAIDiagnosis === 'N' ? 'theme' : null
          });
          break;
        case '/selectLearning' :
          history.replace(`${URL.SELECT_LEARNING}`);
          break;
        default :
        break;
      }
    } else {
      history.replace(`${URL.SELECT_LEARNING}`);
    }

    dispatch(setLearningHistory({
      enterViewPath : null,
    }));
  });

  return {
    learningHistoryInfo,
    setLearningHistoryInfo,
    onLearninStartBtn,
    onLearningExitBtn
  };

};
